module.exports = __webpack_public_path__ + "static/hero-f9405aa337a82ee1072eea722a1f9d3f.svg";